/**
 * Runtime switches for the FX kit, synced from the session store by useFxSync().
 * Kept outside React so games can call fx.* from anywhere (event handlers, socket callbacks).
 */
export interface FxConfig {
  /** reduced motion: no particles/shake/coin rain, durations ×0.3, counters jump */
  reduced: boolean;
  /** sound effects (off by default — honest-play rule 4) */
  sound: boolean;
  /** background music loops (off by default) */
  music: boolean;
  /** navigator.vibrate on supported devices */
  haptics: boolean;
  /** holiday season (GET /api/lobby/season): red / gold sparks and mini lanterns instead of coins — look only */
  festive: boolean;
}

export const fxConfig: FxConfig = {
  reduced: false,
  sound: false,
  music: false,
  haptics: true,
  festive: false,
};

export function configureFx(p: Partial<FxConfig>): void {
  Object.assign(fxConfig, p);
}

/** Duration helper: ×0.3 under reduced motion. */
export function D(ms: number): number {
  return fxConfig.reduced ? Math.round(ms * 0.3) : ms;
}

/** Resolve a theme CSS variable to a concrete colour (canvas cannot use var()). */
export function cssVar(name: string, fallback = '#2EE6C9'): string {
  if (typeof document === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

/** Accepts "--teal", "var(--teal)" or a literal colour. */
export function resolveColor(c: string | undefined, fallback: string): string {
  if (!c) return cssVar(fallback);
  const m = /^var\((--[\w-]+)\)$/.exec(c);
  if (m?.[1]) return cssVar(m[1]);
  if (c.startsWith('--')) return cssVar(c);
  return c;
}
